import { render } from "./HutuAds.vue?vue&type=template&id=5e658a22&scoped=true"
import script from "./HutuAds.vue?vue&type=script&lang=js"
export * from "./HutuAds.vue?vue&type=script&lang=js"

import "./HutuAds.vue?vue&type=style&index=0&id=5e658a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e658a22"]])

export default __exports__